import { ComponentPropsWithRef, forwardRef, ReactNode } from 'react';
import { VariantProps, cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export type ButtonTextProps = ComponentPropsWithRef<'span'> &
  VariantProps<typeof buttonTextVariants> & {
    weight?: 400 | 500 | 700;
    size?: 12 | 14 | 16;
    children: ReactNode;
  };

const ButtonText = forwardRef<HTMLSpanElement, ButtonTextProps>(
  ({ size = 12, weight = 400, className, children, ...props }, ref) => (
    <span ref={ref} className={cn(buttonTextVariants({ size, weight }), className)} {...props}>
      {children}
    </span>
  )
);

ButtonText.displayName = 'ButtonText';

const buttonTextVariants = cva('', {
  variants: {
    size: {
      12: ['text-xs', 'leading-normal'],
      14: ['text-sm', 'leading-normal'],
      16: ['text-base', 'leading-normal'],
    },
    weight: {
      400: 'font-normal',
      500: 'font-medium',
      700: 'font-bold',
    },
  },
});

export default ButtonText;
